<template>
  <div>
    <folder-label :label="subject.name" btn="계획">
      <plan :plan="subject.plan" :lectures="subject.lectures"/>
    </folder-label>
    <mdb-row class="my-2">
      <mdb-col md="4" v-for="(lecture, index) in subject.lectures" :key="index">
        <lecture class="my-1"  :summary="summary" :lecture="lecture"/>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
import lecture from './Lecture'
import FolderLabel from '@/components/common/FolderLabel.vue';
import Plan from '../Plan.vue';
export default {
  name: 'NcsSubject',
  components: { mdbRow, mdbCol, lecture, FolderLabel, Plan },
  props: ['subject', 'summary'],
  data: () => ({
    detail: false
  })
}
</script>
